(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("adminLearningPath", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/accounts/learningPlan/learningPath/adminLearningPathView.html",
            controller: ["learningPlanResource", "messageService", "recognitionService", "authService", "$sessionStorage", "$state", "$uibModal", "_", AdminLearningPathCtrl],
            controllerAs: "vm"
        };
        function AdminLearningPathCtrl(learningPlanResource, messageService, recognitionService, authService, $sessionStorage, $state, $uibModal, _) {
            var vm = this;
            vm.reloadingPath = false;
            vm.view = "path";
            vm.person = $state.params.personSeq;
            if ($sessionStorage.adminLearningPlanView) {
                vm.view = $sessionStorage.adminLearningPlanView === "list" ? "list" : "path";
            }
            loadPath();
            /////////////////////////////////////////////////////////////////////////
            function loadPath() {
                vm.reloadingPath = true; //Use this to remove and recreate the path every time we load it
                learningPlanResource.get({ personSeq: vm.person, number: $state.params.number, version: $state.params.version }, function (data) {
                    vm.data = data;
                    vm.data.number = $state.params.number;
                    vm.data.version = $state.params.version;
                    vm.data.priority = _.some(vm.data.items, { 'showAlertIcon': true });
                    vm.showCompleteButton = data.status !== 3 && authService.isSuperAdmin();
                    vm.canUpdateAccessExpiresDate = !!data.accessExpiresDate && (data.status === 1 || data.status === 2 || data.status === 6);
                    if (data.accessExtendedUntilDate)
                        vm.accessExpiresDate = data.accessExtendedUntilDate;
                    else if (data.accessExpiresDate)
                        vm.accessExpiresDate = data.accessExpiresDate;
                    vm.reloadingPath = false;
                }, function (error) {
                    messageService.error(error);
                });
            }
            vm.changeView = function (view) {
                vm.view = view;
            };
            vm.changeAccessExpiresDate = function () {
                var modal = $uibModal.open({
                    component: "updateAccessExpiresDateModal",
                    resolve: {
                        data: function () {
                            return vm.data;
                        },
                        loadComponent: ["$ocLazyLoad", function ($ocLazyLoad) {
                                return import(
                                /* webpackChunkName: "updateAccessExpiresDateModal" */
                                "./modal/updateAccessExpiresDateModal.component").then(function (mod) { return $ocLazyLoad.load(mod.updateAccessExpiresDateModal); });
                            }]
                    },
                });
                modal.result.then(function () {
                    loadPath();
                }).catch(angular.noop);
            };
            vm.openRecognition = function () {
                vm.data.personSeq = vm.person;
                recognitionService.openAdminView(vm.data);
            };
            vm.openItem = function (item) {
                var modal = $uibModal.open({
                    component: "adminItemModal",
                    resolve: {
                        data: function () {
                            return item;
                        },
                        loadComponent: ["$ocLazyLoad", function ($ocLazyLoad) {
                                return import(
                                /* webpackChunkName: "adminItemModal" */
                                "./modal/adminItemModal.component").then(function (mod) { return $ocLazyLoad.load(mod.adminItemModal); });
                            }]
                    },
                });
                modal.result.then(function (mode) {
                    openUpdateStatusItemModal(item, mode);
                }).catch(angular.noop);
            };
            function openUpdateStatusItemModal(item, mode) {
                var modal = $uibModal.open({
                    component: "updateStatusItemModal",
                    resolve: {
                        mode: function () {
                            return mode;
                        },
                        item: function () {
                            return item;
                        },
                        loadComponent: ["$ocLazyLoad", function ($ocLazyLoad) {
                                return import(
                                /* webpackChunkName: "updateStatusItemModal" */
                                "./modal/updateStatusItemModal.component").then(function (mod) { return $ocLazyLoad.load(mod.updateStatusItemModal); });
                            }]
                    }
                });
                modal.result.then(function () {
                    $state.reload();
                }).catch(angular.noop);
            }
            vm.completePath = function () {
                var modal = $uibModal.open({
                    templateUrl: "app/accounts/learningPlan/learningPath/completeLearningPathConfirmationModalView.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function (data) {
                    learningPlanResource.complete({ personSeq: vm.person, number: $state.params.number, version: $state.params.version }, { value: data }, function () {
                        messageService.success("account.learningPlan.pathCompleted");
                        loadPath();
                    }, function (error) {
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
        }
    });
}());
